import { Paper, styled } from "@mui/material";

export const Content = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(7)};
  width: 80vw;
  max-width: 500px;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: ${({ theme }) => theme.spacing(3)};
  }

  &.bare {
    background-color: transparent;
    box-shadow: none;
  }
`;
